import { render, staticRenderFns } from "./liveness.vue?vue&type=template&id=533b749a&"
import script from "./liveness.vue?vue&type=script&lang=js&"
export * from "./liveness.vue?vue&type=script&lang=js&"
import style0 from "./liveness.vue?vue&type=style&index=0&id=533b749a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports